import { render, staticRenderFns } from "./CompanyDisplaySettingsContent.vue?vue&type=template&id=4fde8f0e&scoped=true&"
import script from "./CompanyDisplaySettingsContent.vue?vue&type=script&lang=js&"
export * from "./CompanyDisplaySettingsContent.vue?vue&type=script&lang=js&"
import style0 from "./CompanyDisplaySettingsContent.vue?vue&type=style&index=0&id=4fde8f0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fde8f0e",
  null
  
)

export default component.exports